/**
 * @flow
 */
'use strict';

export const santeMedicament1Codes = [
{"code":"Acular"},
{"code":"Alphagan"},
{"code":"Alphagan P"},
{"code":"Asthme"},
{"code":"Attn p-e steroid responder ?"},
{"code":"Azarga"},
{"code":"Azopt"},
{"code":"Blink"},
{"code":"Botox"},
{"code":"Brimonidine"},
{"code":"Buckle"},
{"code":"Celluvisc"},
{"code":"Chol. auparavant, pas med"},
{"code":"Ciprofloxacin"},
{"code":"Clear eye/ red eye"},
{"code":"Combigan"},
{"code":"Cosopt"},
{"code":"Cromolin"},
{"code":"Diamox"},
{"code":"Duotrav"},
{"code":"Fucithalmic"},
{"code":"Homatropine"},
{"code":"Hylo"},
{"code":"Impatience musculaire"},
{"code":"Inflammase"},
{"code":"Injection"},
{"code":"Iso-carpine"},
{"code":"Isopto tears"},
{"code":"LA visine"},
{"code":"Lacrilube"},
{"code":"Larmes artificielles"},
{"code":"Latanoprost"},
{"code":"Lidocaïne"},
{"code":"Lotemax"},
{"code":"Lumigan"},
{"code":"Lutéine PO"},
{"code":"Muro 128"},
{"code":"Nevanac"},
{"code":"Normale"},
{"code":"Ocuvite"},
{"code":"Ocuvite 50+"},
{"code":"Oeil artificiel"},
{"code":"Omega 3"},
{"code":"Pas de strabisme"},
{"code":"Pas gtts"},
{"code":"Pas méds"},
{"code":"Pataday"},
{"code":"Patanol"},
{"code":"Pierres au rein"},
{"code":"Pilocarpine"},
{"code":"Polysporin"},
{"code":"Prednisolone"},
{"code":"Preservision"},
{"code":"Prothèse OD"},
{"code":"Prothèse OG"},
{"code":"Refresh"},
{"code":"Refresh Optive Advanced "},
{"code":"Refresh advance"},
{"code":"Refresh contacts"},
{"code":"Refresh optive"},
{"code":"Refresh optive fusion"},
{"code":"Refresh tears"},
{"code":"Restasis"},
{"code":"Risperdal"},
{"code":"Simbrinza"},
{"code":"Systane"},
{"code":"Systane Ultra"},
{"code":"Systane balance"},
{"code":"Systane gel"},
{"code":"Systane vitamine"},
{"code":"Tear"},
{"code":"Tear gel"},
{"code":"Thera pearl"},
{"code":"Timolol"},
{"code":"Timolol maleate Ex"},
{"code":"Timoptic"},
{"code":"Timoptic xe"},
{"code":"Tobradex"},
{"code":"Travatan"},
{"code":"Travatan z"},
{"code":"Trusopt"},
{"code":"Vigamox"},
{"code":"Visine"},
{"code":"Vitalux"},
{"code":"Vitalux S"},
{"code":"Vitalux advanced"},
{"code":"Vitalux chewable"},
{"code":"Vitalux omega 3"},
{"code":"Vitalux-S + omega 3"},
{"code":"Voltaren"},
{"code":"Xalacom"},
{"code":"Xalatan"},
{"code":"Xalatan ?"},
{"code":"Xalatan qhs OU"},
{"code":"Zaditor"},
]
